import Form from "./Form";

export type { IFormProps } from "./Form";

export default Form;
